// @ts-expect-error
/* eslint-disable */
import { request } from '@umijs/max';

/** 14001-获取当前用户权限 获取当前登录用户的权限树（包含菜单和按钮） GET /web/v1/auth/me/permissions */
export async function getCurrentUserPermissions(options?: {
  [key: string]: any;
}) {
  return request<API.YmResultVOListPermissionTreeVo>(
    '/web/v1/auth/me/permissions',
    {
      method: 'GET',
      ...(options || {}),
    },
  );
}
